import { useEffect, useState } from "react";
import { axiosPrivate } from "../../../api/axios";
import { useMutation } from "@tanstack/react-query";
import { motion } from "framer-motion";





const MapSearch = ({ MapAPIkey, setLngCache, setLatCache }: any) => {

    const [search, setSearch] = useState<string>('');
    const [data, setData] = useState<any>(undefined);
    const [placeholder, setPlaceholder] = useState<any>(undefined);

    const getPlacesContent = (data: any) =>
        axiosPrivate
            .get(
                `https://api.maptiler.com/geocoding/${data}.json?key=${MapAPIkey}&language=fa&country=ir`,
                {
                    headers: {
                        // prettier-ignore
                        "accept": "application/json",
                        // prettier-ignore
                        // "Content-Type": "multipart/form-data",
                    },
                    withCredentials: false,
                }
            )
            .then((res) => res?.data.features);

    const placesMutate = useMutation({
        mutationFn: (data: any) => getPlacesContent(data),
        onSuccess(data, variables, context) {
            setData(data)
        },
    });


    useEffect(() => {
        placesMutate.mutate(search)
    }, [search])


    const modalHeightVariants = {
        initial: {
          height: 0,
          opacity: 0,
        },
        final: {
          height: "auto",
          opacity: 1,
          transition: {
            duration: 0.5,
            delay: 0.2,
          },
        },
      };
      
    return (
        <div className="flex min-w-24 w-full m-1 max-sm:max-w-[327px] max-w-80 flex-col justify-center gap-1 items-center z-10 opacity-90 absolute top-0 right-0">

            <div className="flex w-full gap-1 bg-white p-1 justify-center items-cente border border-gray-200 rounded-md">
                <img src="/icons/search.svg" alt="search.svg not found" />
                <input type="search" value={search} className=" focus:outline-none p-1 w-full" placeholder={`${placeholder ? `${placeholder}` : `جستجو مکان`}`} onChange={(e) => setSearch(e.target.value)} />

            </div>


            {search !== '' && data?.length !== 0 ? (<motion.div           layout
          variants={modalHeightVariants}
          initial="initial"
          animate="final" style={{scrollbarWidth: "thin"}} className="flex w-full  flex-col gap-1 overflow-y-scroll min-h-11 max-h-52 bg-white p-1 rounded-md">
                {data?.map((item: any, index: number) => (
                    <div onClick={() => {setLngCache(item?.center[0]); setLatCache(item?.center[1]); setSearch(''); setData([]); setPlaceholder(item?.place_name_fa)}} className="flex justify-center cursor-pointer p-1 items-center w-full bg-gray-50 border border-gray-200 rounded-md">
                        <p className="text-gray-900 text-BodyText/14/Medium">{item?.place_name_fa}</p>
                    </div>
                ))}
            </motion.div>) : null}
        </div>
    )
}

export default MapSearch;